
  Vue.component('vue-recaptcha', VueRecaptcha.VueRecaptcha)

  Vue.component('dynamic-form-item-sector', {
    props: {
      fieldName: { type: String, required: true },
      id: { type: [String, Number], required: true },
      label: { type: String, required: true },
      required: { type: Boolean, default: false },
      value: { type: String, default: '' },
      inputClass: { type: Array, default: () => [] },
      validationMessage: { type: Array, default: () => [] },
      onFocus: { type: Boolean, default: false },
      readOnly: { type: Boolean, default: false },
      getFieldValue: { type: Function, default: fieldName => null }
    },
    data() {
      return {
        isEditing: false,
        isLoading: false,
        sectorData: null,
        localValue: this.value || '',
        initialValue: this.value || '',
        newSkill: '',
        skillsField: {
          id: 103,
          fieldName: 'txtProfessionalProfile',
          label: 'Professioni',
          validators: [{ type: 'XXXrequired' }],
          inputClass: ['cities-typeahead'],
          typeahead: {
            bloodhoundSource: skills,
            labelProp: 'Label',
            sortProp: 'Label',
            valueNotInList: true
          }
        }
      }
    },
    template: '#dynamic-form-item-sector',
    computed: {
      allSkills() {
        if (!this.sectorData) return []
        return [
          ...new Set([...(this.sectorData.ProfessionalProfiles || []), ...(this.sectorData.SelectedSkills || [])])
        ]
      }
    },
    watch: {
      sectorData: {
        deep: true,
        handler(newValue) {
          const value = JSON.stringify(newValue)
          this.$emit('parentInput', { fieldName: 'jsonSectorData', value })
        }
      },
      value(newValue) {
        if (this.getFieldValue('jsonSectorData')) {
          const sectorData = JSON.parse(this.getFieldValue('jsonSectorData'))
          this.sectorData = {
            SectorKeywords: sectorData.SectorKeywords || [],
            ProfessionalProfiles: sectorData.ProfessionalProfiles || [],
            SelectedSkills: sectorData.SelectedSkills || []
          }
        }
        if (newValue) {
          this.localValue = newValue
          if (!this.sectorData && !this.isEditing) {
            this.fetchData()
          }
        }
      }
    },
    methods: {
      setNewSkillValue(field) {
        this.newSkill = field.value
      },
      confirmNewSkillValue(field) {
        this.addSkill()
        this.newSkill = ''
      },
      emitInterface() {
        const self = this
        this.$emit('interface', {
          key: self.fieldName,
          validate: () => self.validate(),
          containerRef: self.$refs.container
        })
      },
      startEdit() {
        this.initialValue = this.localValue
        this.isEditing = true
      },
      cancelEdit() {
        this.isEditing = false
      },
      confirmEdit() {
        if (!this.localValue) {
          this.isEditing = false
        } else {
          this.fetchData()
        }
      },
      fetchData() {
        if (!this.localValue || this.localValue === this.initialValue) {
          this.isEditing = false
          return
        }

        this.isLoading = true
        axios
          .post('/api/v1/subscriptions/get-sector-data-from-description', { desc: this.localValue })
          .then(response => {
            const responseData = response.data

            if (!responseData || responseData === '') {
              console.warn("La risposta dell'API è nulla o vuota.")
              return
            }

            // Inizializza sectorData se è null o undefined
            if (!this.sectorData) {
              this.sectorData = { SectorKeywords: [], ProfessionalProfiles: [], SelectedSkills: [] }
            }

            this.sectorData = {
              SectorKeywords: [
                ...new Set([...(response.data.SectorKeywords || [] || []), ...(this.sectorData?.SectorKeywords || [])])
              ],
              ProfessionalProfiles: [
                ...new Set([
                  ...(response.data.ProfessionalProfiles || []),
                  ...(this.sectorData?.ProfessionalProfiles || [])
                ])
              ],
              SelectedSkills: [...(this.sectorData.SelectedSkills || [])]
            }

            this.isEditing = false
            this.$emit('confirm')
          })
          .catch(error => {
            console.error('Errore nella chiamata API:', error)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      toggleSkill(skill) {
        if (!this.sectorData) return // Evita errori se sectorData è null

        const selected = this.sectorData.SelectedSkills || []
        if (selected.includes(skill)) {
          this.sectorData.SelectedSkills = selected.filter(s => s !== skill)
        } else {
          this.addSkill()
        }
      },
      addSkill() {
        if (!this.sectorData) return // Evita errori se sectorData è null

        if (this.newSkill.trim() && !this.allSkills.includes(this.newSkill.trim())) {
          if (this.sectorData.SelectedSkills) this.sectorData.SelectedSkills.push(this.newSkill.trim())
          else this.sectorData.SelectedSkills = [this.newSkill.trim()]
          setTimeout(() => (this.newSkill = ''), 100)
        }
      },
      removeSkill(skill) {
        if (!this.sectorData) return // Evita errori se sectorData è null

        this.sectorData.ProfessionalProfiles = (this.sectorData.ProfessionalProfiles || []).filter(s => s !== skill)
        this.sectorData.SelectedSkills = (this.sectorData.SelectedSkills || []).filter(s => s !== skill)
      },
      handleOverlayClick(event) {
        const textarea = this.$refs.input
        if (textarea && event.target !== textarea) {
          textarea.focus()
        }
      }
    },
    mounted() {
      this.emitInterface()
    }
  })
